const Items = [
    {
        number: 1,
        question: 'Que no me pertenezco a mí mismo,1 sino que pertenezco–en cuerpo y alma, en la vida y en la muerte2—a mi fiel Salvador, Jesucristo,3 quien pagó por completo todos mis pecados con su preciosa sangre,4 y me ha liberado de la tiranía del diablo.5 También cuida de mí de tal manera6 que ni un solo cabello de mi cabeza puede caer sin la voluntad de mi Padre que está en el cielo;7 por cierto, es necesario que todas las cosas colaboren para mi salvación.8 Porque pertenezco a Cristo, él mediante su Espíritu me asegura la vida eterna,9 y me hace completamente dispuesto y listo para vivir para él de ahora en adelante.10',
        proofs: [
            {
                punto: '1',
                ref: '1 Corintios 6:19-20',
                text: '¿O no sabéis que vuestro cuerpo es templo del Espíritu Santo, que está en vosotros, el cual tenéis de Dios, y que no sois vuestros? Pues por precio habéis sido comprados; por tanto, glorificad a Dios en vuestro cuerpo y en vuestro espíritu, los cuales son de Dios.'
            },
            {
                punto: '2',
                ref: 'Romanos 14:7-9',
                text: 'Porque ninguno de nosotros vive para sí mismo, y ninguno muere para sí mismo; pues si vivimos, para el Señor vivimos, y si morimos, para el Señor morimos; por tanto, ya sea que vivamos o que muramos, del Señor somos. Porque para esto Cristo murió y resucitó, para ser Señor tanto de los muertos como de los vivos.'
            },
            {
                punto: '3',
                ref: '1 Corintios 3:23; Tito 2:14',
                text: ['y vosotros de Cristo, y Cristo de Dios.', 'quien se dio a sí mismo por nosotros, para redimirnos de toda iniquidad y purificar para si un pueblo para posesión suya, celoso de buenas obras.']
            },
            {
                punto: 'c',
                ref: 'Tito 2:14',
                text: 'quien se dio a sí mismo por nosotros, para redimirnos de toda iniquidad y purificar para si un pueblo para posesión suya, celoso de buenas obras.'
            },
            {
                punto: 'd',
                ref: 'Hebreos 2:14',
                text: 'Así que, por cuanto los hijos participan de carne y sangre, Él igualmente participó también de lo mismo, para anular mediante la muerte el poder de aquel que tenía el poder de la muerte, es decir, el diablo,'
            },
            {
                punto: 'd',
                ref: '1 Juan 3:8',
                text: 'El que practica el pecado es del diablo, porque el diablo ha pecado desde el principio. El Hijo de Dios se manifestó con este propósito: para destruir las obras del diablo.'
            },
            {
                punto: 'd',
                ref: 'Juan 8:34-36',
                text: 'Jesús les respondió: En verdad, en verdad os digo que todo el que comete pecado es esclavo del pecado; y el esclavo no queda en la casa para siempre; el hijo sí permanece para siempre. Así que, si el Hijo os hace libres, seréis realmente libres.'
            },
            {
                punto: 'e',
                ref: '1 Pedro 1:18-19',
                text: 'sabiendo que no fuisteis redimidos de vuestra vana manera de vivir heredada de vuestros padres con cosas perecederas como oro o plata, sino con sangre preciosa, como de un cordero sin tacha y sin mancha, la sangre de Cristo.'
            },
            {
                punto: 'e',
                ref: '1 Juan 1:7',
                text: 'mas si andamos en la luz, como Él está en la luz, tenemos comunión los unos con los otros, y la sangre de Jesús su Hijo nos limpia de todo pecado.'
            },
            {
                punto: 'e',
                ref: '1 Juan 2:22',
                text: '¿Quién es el mentiroso, sino el que niega que Jesús es el Cristo? Este es el anticristo, el que niega al Padre y al Hijo.'
            },
            {
                punto: 'f',
                ref: 'Juan 6:39',
                text: 'Y esta es la voluntad del que me envió: que de todo lo que Él me ha dado yo no pierda nada, sino que lo resucite en el día final.'
            },
            {
                punto: 'f',
                ref: 'Juan 10:28',
                text: 'y yo les doy vida eterna y jamás perecerán, y nadie las arrebatará de mi mano.'
            },
            {
                punto: 'f',
                ref: '2 Tesalonicenses 3:3',
                text: 'Pero fiel es el Señor quien os fortalecerá y protegerá del maligno.'
            },
            {
                punto: 'f',
                ref: '1 Pedro 1:5',
                text: 'que sois protegidos por el poder de Dios mediante la fe, para la salvación que está preparada para ser revelada en el último tiempo.'
            },
            {
                punto: 'g',
                ref: 'Mateo 10:30',
                text: 'Y hasta los cabellos de vuestra cabeza están todos contados.'
            },
            {
                punto: 'g',
                ref: 'Lucas 21:18',
                text: 'Sin embargo, ni un cabello de vuestra cabeza perecerá.'
            },
            {
                punto: 'h',
                ref: 'Romanos 8:28',
                text: 'Y sabemos que para los que aman a Dios, todas las cosas cooperan para bien, esto es, para los que son llamados conforme a su propósito.'
            },
            {
                punto: 'i',
                ref: '2 Corintios 1:22',
                text: 'quien también nos selló y nos dio el Espíritu en nuestro corazón como garantía.'
            },
            {
                punto: 'i',
                ref: '2 Corintios 5:5',
                text: 'Y el que nos preparó para esto mismo es Dios, quien nos dio el Espíritu como garantía.'
            },
            {
                punto: 'i',
                ref: 'Efesios 1:14',
                text: 'que nos es dado como garantía de nuestra herencia, con miras a la redención de la posesión adquirida de Dios, para alabanza de su gloria.'
            },
            {
                punto: 'i',
                ref: 'Romanos 8:16',
                text: 'El Espíritu mismo da testimonio a nuestro espíritu de que somos hijos de Dios,'
            },
            {
                punto: 'j',
                ref: 'Romanos 8:14',
                text: 'Porque todos los que son guiados por el Espíritu de Dios, los tales son hijos de Dios.'
            },
            {
                punto: 'j',
                ref: '1 Juan 3:3',
                text: 'Y todo el que tiene esta esperanza puesta en Él, se purifica, así como Él es puro.'
            },
        ]
    },
    {
        number: 2,
        question: '¿Cuántas cosas debes saber para que, gozando de esta consolación, puedas vivir y morir dichosamente?',
        answer: 'Tres: (a) La primera, cuán grande son mis pecados y miserias (b). La segunda, de qué manera puedo ser librado de ellos. (c) Y la tercera, la gratitud que debo a Dios por su redención.',
        proofs: [
            {
                punto: 'a',
                ref: 'Mateo 11:28-30',
                text: 'Venid a mí, todos los que estáis cansados y cargados, y yo os haré descansar. Tomad mi yugo sobre vosotros y aprended de mí, que soy manso y humilde de corazón, y hallareis descanso para vuestras almas. Porque mi yugo es fácil y mi carga ligera.'
            },
            {
                punto: 'b',
                ref: 'Efesios 5:8',
                text: 'porque antes erais tinieblas, pero ahora sois luz en el Señor; andad como hijos de la luz'
            },
            {
                punto: 'b',
                ref: 'Juan 9:4',
                text: 'Nosotros debemos hacer las obras del que me envió mientras es de día; la noche viene cuando nadie puede trabajar.'
            },
            {
                punto: 'b',
                ref: 'Romanos 3:10',
                text: 'como está escrito: No hay justo, ni aun uno;'
            },
            {
                punto: 'b',
                ref: 'Juan 1:9',
                text: 'Existía la luz verdadera que, al venir al mundo, alumbra a todo hombre.'
            },

            {
                punto: 'c',
                ref: 'Juan 17:3',
                text: 'Y esta es la vida eterna: que te conozcan a ti, el único Dios verdadero, y a Jesucristo, a quien has enviado.'
            },
            {
                punto: 'c',
                ref: 'Hechos 10:43',
                text: 'De este dan testimonio todos los profetas, de que por su nombre, todo el que cree en Él recibe el perdón de los pecados.'
            },
            {
                punto: 'c',
                ref: 'Hechos 4:12',
                text: 'Y en ningún otro hay salvación, porque no hay otro nombre bajo el cielo dado a los hombres, en el cual podamos ser salvos.'
            },
            {
                punto: 'c',
                ref: 'Efesios 5:10',
                text: 'examinando qué es lo que agrada al Señor.'
            },
            {
                punto: 'c',
                ref: 'Salmo 50:14',
                text: 'Ofrece a Dios sacrificio de acción de gracias, y cumple tus votos al Altísimo;'
            },
            {
                punto: 'c',
                ref: 'Mateo 5:16',
                text: 'Así brille vuestra luz delante de los hombres, para que vean vuestras buenas acciones y glorifiquen a vuestro Padre que está en los cielos.'
            },
            {
                punto: 'c',
                ref: '1 Pedro 2:12',
                text: 'Mantened entre los gentiles una conducta irreprochable, a fin de que en aquello que os calumnian como malhechores, ellos, por razón de vuestras buenas obras, al considerarlas, glorifiquen a Dios en el día de la visitación.'
            },
            {
                punto: 'c',
                ref: '2 Tesalonicenses 3:3',
                text: 'Pero fiel es el Señor quien os fortalecerá y protegerá del maligno.'
            },
            {
                punto: 'c',
                ref: 'Romanos 6:13',
                text: 'ni presentéis los miembros de vuestro cuerpo al pecado como instrumentos de iniquidad, sino presentaos vosotros mismos a Dios como vivos de entre los muertos, y vuestros miembros a Dios como instrumentos de justicia.'
            },

            {
                punto: 'c',
                ref: '2 Timoteo 2:15',
                text: 'Procura con diligencia presentarte a Dios aprobado, como obrero que no tiene de qué avergonzarse, que maneja con precisión la palabra de verdad.'
            }
        ]
    },
];

export default Items;
